// extracted by mini-css-extract-plugin
module.exports = {"newswell":"newsdock-module--newswell--25rBH"};